import { fetchCompanyStatsPCUGames } from '@/pages/intelligence/services/companies';

export async function getPCUGamesCardData(params, tabId) {
  // 加载数据，例如从 API
  // 使用 applyFilter 筛选数据
  // 渲染卡片
  try {
    const gamesRes = await fetchCompanyStatsPCUGames(params);
    //1 aggregated为可视化柱状和饼， 需要过滤掉allgame
    //2 表格数据排序和分页需要重新调接口，但可视化不需要更新
    //3 请求折线图接口，需要给top5游戏数据，页面改变筛选器才重新请求

    const tableData = gamesRes?.data?.game_share_data_list || [];
    // const fixedData = gamesRes?.data?.game_share_data_total || [];
    const gameTotal = gamesRes?.data?.total_count || 0;
    const lineData = gamesRes?.data?.game_share_metric_time_line || [];
    // const barOrPieData = gamesRes?.data?.game_share_pie_chart || [];

    const foundMetric = lineData?.find((item: any) => item?.metric === 'PCU');

    return {
      cardStats: {
        isLoading: false,
        isError: false,
        isNoData: !gameTotal,
      },
      lineData: foundMetric?.history || [],
      tableData: tableData,
      total: gameTotal,
      startDate: gamesRes?.data?.start_data_time || '',
      endDate: gamesRes?.data?.end_data_time || '',
    };
  } catch (err) {
    return {
      cardStats: {
        isLoading: false,
        isError: true,
        isNoData: true,
      },
      lineData: [],
      tableData: [],
      total: 0,
      startDate: '',
      endDate: '',
    };
  }
}
